import { QuoteFilterOptions } from '~/lib/quotes';
import { QuoteFilterCheckbox } from './quote-filter-section';
import { P2GBox } from '@parcel2go/core-ui';

export default function DropOffRequired({
  filter,
  onChange,
  label
}: {
  label: string;
  filter: QuoteFilterOptions;
  onChange: (filter: QuoteFilterOptions) => void;
}) {
  const isSelected = !!filter.serviceType?.includes('Drop Off');
  return (
    <P2GBox style={{ opacity: filter.serviceType !== 'Collection' ? 1 : 0.3, transition: 'opacity 0.5s' }}>
      <QuoteFilterCheckbox
        disable={false}
        isSelected={isSelected}
        onClick={() => {
          onChange({
            ...filter,
            serviceType: isSelected ? undefined : 'Drop Off'
          });
        }}
        label={label}
      />
    </P2GBox>
  );
}
